import TechnologyCard from "../../components/Cards/TechnologyCard"
import { TECH_STACK } from "../../constants/constants"
import "./Technologies.scss"

export default function Technologies() {
    return (
        <div className="technologies-section row">
            <div className="right-section d-flex flex-column col-12 col-sm-6">
                <TechnologyCard number={TECH_STACK.ONE.number} technology={TECH_STACK.ONE.name} />
                <TechnologyCard number={TECH_STACK.THREE.number} technology={TECH_STACK.THREE.name} />
                <TechnologyCard number={TECH_STACK.FIVE.number} technology={TECH_STACK.FIVE.name} duration="months" />
                <TechnologyCard number={TECH_STACK.SEVEN.number} technology={TECH_STACK.SEVEN.name} />
                <TechnologyCard number={TECH_STACK.NINE.number} technology={TECH_STACK.NINE.name} />
                <TechnologyCard number={TECH_STACK.ELEVEN.number} technology={TECH_STACK.ELEVEN.name} duration="months" />
                <TechnologyCard number={TECH_STACK.THIRTEEN.number} technology={TECH_STACK.THIRTEEN.name} />
                <TechnologyCard number={TECH_STACK.FIFTEEN.number} technology={TECH_STACK.FIFTEEN.name} />
                <TechnologyCard number={TECH_STACK.SEVENTEEN.number} technology={TECH_STACK.SEVENTEEN.name} />
                <TechnologyCard number={TECH_STACK.NINETEEN.number} technology={TECH_STACK.NINETEEN.name} duration="months" />
                <TechnologyCard number={TECH_STACK.TWENTY_ONE.number} technology={TECH_STACK.TWENTY_ONE.name} />
            </div>
            <div className="left-section col-12 col-sm-6">
                <TechnologyCard number={TECH_STACK.TWO.number} technology={TECH_STACK.TWO.name} />
                <TechnologyCard number={TECH_STACK.FOUR.number} technology={TECH_STACK.FOUR.name} />
                <TechnologyCard number={TECH_STACK.SIX.number} technology={TECH_STACK.SIX.name} />
                <TechnologyCard number={TECH_STACK.EIGHT.number} technology={TECH_STACK.EIGHT.name} />
                <TechnologyCard number={TECH_STACK.TEN.number} technology={TECH_STACK.TEN.name} />
                <TechnologyCard number={TECH_STACK.TWELVE.number} technology={TECH_STACK.TWELVE.name} />
                <TechnologyCard number={TECH_STACK.FOURTEEN.number} technology={TECH_STACK.FOURTEEN.name} />
                <TechnologyCard number={TECH_STACK.SIXTEEN.number} technology={TECH_STACK.SIXTEEN.name} />
                <TechnologyCard number={TECH_STACK.EIGHTEEN.number} technology={TECH_STACK.EIGHTEEN.name} />
                <TechnologyCard number={TECH_STACK.TWENTY.number} technology={TECH_STACK.TWENTY.name} duration="months" />
                <TechnologyCard number={TECH_STACK.TWENTY_TWO.number} technology={TECH_STACK.TWENTY_TWO.name} />
            </div>
        </div>
    )
}